import { cx } from '@linaria/core';
import { useEffect, useState } from 'react';

import { routes } from '~constants/routes';
import { Link } from '~i18n/navigation';
import { ParticlesPlaceholder } from '~shared/ui/atoms';
import { Avatar } from '~shared/ui/organisms';
import { TypingIndicator } from '~widgets/Contacts/ui/ContactsItem/TypingIndicator';

import type { MappedDialogParticipant } from '../../types';
import { CountBadge } from '../CountBadge';
import {
	BottomRow,
	Container,
	InfoBox,
	Message,
	Name,
	PhotoBox,
	PlaceholderWrapper,
	TopRow,
} from './styles';

type Props = {
	bot: MappedDialogParticipant;
	isActive?: boolean;
	onClick?: () => void;
};

export const ContactsItem = ({ bot, isActive, onClick }: Props) => {
	const {
		clientId,
		name,
		avatar,
		avatarFallback,
		lastMessage,
		accountType,
		showPaid,
		paymentOptionText,
		isTyping,
	} = bot;

	const isInfluencer = accountType === 'influencer';

	const [showTyping, setShowTyping] = useState(false);
	useEffect(() => {
		if (isTyping) {
			const timeout = setTimeout(() => setShowTyping(isTyping), 500);
			return () => clearTimeout(timeout);
		} else {
			setShowTyping(isTyping);
		}
	}, [setShowTyping, isTyping]);

	const TextContent = lastMessage ? (
		<BottomRow>
			{showPaid && lastMessage.isSexting ? (
				<PlaceholderWrapper>
					<ParticlesPlaceholder />
				</PlaceholderWrapper>
			) : (
				<Message
					size="M"
					align="left"
					isSexting={lastMessage.isSexting}
					isUnread={bot.unreadCount > 0}
				>
					{lastMessage.text}
				</Message>
			)}
			{bot.unreadCount > 0 && <CountBadge count={bot.unreadCount} />}
		</BottomRow>
	) : paymentOptionText ? (
		<BottomRow>
			<Message size="M" align="left">
				{paymentOptionText}
			</Message>
		</BottomRow>
	) : null;

	const Inner = (
		<Container className={cx(isActive && 'active')}>
			<PhotoBox>
				<Avatar
					avatar={avatar}
					avatarFallback={avatarFallback ?? undefined}
					ticked={isInfluencer}
				/>
			</PhotoBox>

			<InfoBox>
				<TopRow>
					<Name align="left" size="M">
						{name}
					</Name>
				</TopRow>
				{showTyping ? <TypingIndicator /> : TextContent}
			</InfoBox>
		</Container>
	);

	return (
		<Link href={routes.chats.dialog(clientId)} onClick={onClick}>
			{Inner}
		</Link>
	);
};
